import ApiErrorResponse from "@eryxcoop/appyx-comm/src/responses/generalResponses/ApiErrorResponse";

export default class EditOrderErrorResponse extends ApiErrorResponse {
    static defaultResponse() {
        return {
            object: {
            },
            errors: [
                {
                    'code': 'cannot_edit_order_when_its_not_in_initial_state',
                    'text': "Can`t edit an order which is not in initial state"
                }
            ]
        }
    }

    static errorCodes() {
        return ['cannot_edit_order_when_its_not_in_initial_state'];
    }

    editionFailed() {
        return true;
    }
}